
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import { CustomerGroup as CustomerGroupEnum } from '@/enums/CustomerGroup';
import { Venue } from '@/interfaces/models/Venue';
import { venueFilter, debounce } from '@/util/helper';

interface Selection {
  search?: string;
  venue?: string;
  customerGroup?: string;
}

@Component
export default class PromoCodeFilter extends Vue {
  @Prop({ type: Array, required: true }) public customerGroups!: CustomerGroupEnum[];
  @Prop({ type: Array, required: true }) public venues!: Venue[];
  @Prop({ type: Object }) public venue!: Venue;

  public search: string = '';
  public selectedVenue: string | null = '';
  public selectedCustomerGroup: string = '';

  get selection() {
    const selection: Selection = {};

    if (this.search !== '') {
      selection.search = this.search;
    }

    if (this.selectedVenue) {
      selection.venue = this.selectedVenue;
    }

    if (this.selectedCustomerGroup) {
      selection.customerGroup = this.selectedCustomerGroup;
    }

    return selection;
  }

  public filter(item: Venue, queryText: string): boolean {
    return venueFilter(item, queryText);
  }

  public created() {
    this.search = (this.$route.query.search as string) || '';
  }

  @Watch('selection')
  @Emit('change')
  public onSelectionChange() {
    this.$router.replace({ query: { ...this.$route.query, search: this.search } }).catch(() => {});
    return this.selection;
  }
}
